/* Old Phone Club — Web Components */
'use strict';

/* ─── Hero Carousel ─── */
class OpcHeroCarousel extends HTMLElement {
  connectedCallback() {
    this._index = 0;
    this._slides = Array.from(this.querySelectorAll('.opc-hero-carousel__slide'));
    this._dots   = Array.from(this.querySelectorAll('.opc-hero-carousel__dot'));

    this.querySelector('[data-prev]')?.addEventListener('click', () => this._go(this._index - 1));
    this.querySelector('[data-next]')?.addEventListener('click', () => this._go(this._index + 1));
    this._dots.forEach((d, i) => d.addEventListener('click', () => this._go(i)));

    if (this.hasAttribute('autoplay')) {
      this._timer = setInterval(() => this._go(this._index + 1), 5000);
    }
  }
  disconnectedCallback() { clearInterval(this._timer); }
  _go(i) {
    const n = this._slides.length;
    if (!n) return;
    this._index = ((i % n) + n) % n;
    this._slides.forEach((s, j) => s.setAttribute('aria-current', String(j === this._index)));
    this._dots.forEach((d, j) => d.setAttribute('aria-current', String(j === this._index)));
  }
}
customElements.define('opc-hero-carousel', OpcHeroCarousel);

/* ─── Ticker ─── */
class OpcTicker extends HTMLElement {
  connectedCallback() {
    const track = this.querySelector('.opc-ticker__track');
    if (!track || track.dataset.duped) return;

    // 1) Répéter la séquence jusqu'à couvrir la largeur de l'écran,
    //    sinon une séquence trop courte laisse un blanc avant la reboucle.
    const seqHTML = track.innerHTML;
    let guard = 0;
    while (track.scrollWidth < this.offsetWidth && guard < 50) {
      track.insertAdjacentHTML('beforeend', seqHTML);
      guard++;
    }

    // 2) Dupliquer l'ensemble une fois → l'animation translateX(-50%) boucle
    //    de façon continue (la 1re moitié couvre déjà l'écran).
    track.innerHTML += track.innerHTML;
    track.dataset.duped = '1';
  }
}
customElements.define('opc-ticker', OpcTicker);

/* ─── Mini-recherche dans les filtres (facets à plus de 8 choix) ─── */
/* Phase CAPTURE + stopPropagation : le champ est dans le <form> des facets ;
   sans ça, facets.js intercepte la frappe (debounce) et re-render la section,
   ce qui efface la liste et le focus. La capture nous laisse filtrer d'abord,
   puis on bloque la propagation vers le listener Dawn du form.
   Délégation sur document → survit aussi aux re-renders. */
function opcFacetSearchFilter(e) {
  if (!e.target.matches('[data-facet-search]')) return;
  e.stopPropagation();
  const wrap = e.target.closest('.opc-facet-search');
  const list = wrap && wrap.nextElementSibling;
  if (!list) return;
  const q = e.target.value.trim().toLowerCase();
  list.querySelectorAll('li').forEach(function (li) {
    const label = li.querySelector('.facet-checkbox__text-label');
    const text = (label ? label.textContent : li.textContent).toLowerCase();
    li.style.display = (q === '' || text.indexOf(q) !== -1) ? '' : 'none';
  });
}
document.addEventListener('input', opcFacetSearchFilter, true);
// Empêche aussi la soumission au blur (event 'change' du champ texte).
document.addEventListener('change', function (e) {
  if (e.target.matches('[data-facet-search]')) e.stopPropagation();
}, true);

/* ─── Nav Drawer (mobile) ─── */
class OpcNavDrawer extends HTMLElement {
  connectedCallback() {
    this.querySelector('[data-drawer-open]')?.addEventListener('click', () => this._open());
    this.querySelector('[data-drawer-close]')?.addEventListener('click', () => this._close());
    this.querySelector('.opc-nav-drawer__overlay')?.addEventListener('click', () => this._close());
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this._close(); });
  }
  _open()  { this.querySelector('.opc-nav-drawer')?.setAttribute('open', ''); document.body.style.overflow = 'hidden'; }
  _close() { this.querySelector('.opc-nav-drawer')?.removeAttribute('open'); document.body.style.overflow = ''; }
}
customElements.define('opc-nav-drawer', OpcNavDrawer);

/* ─── Cart count update ─── */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const data = new FormData(form);
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', body: data });
        if (res.ok) {
          const cart = await fetch('/cart.js').then(r => r.json());
          document.querySelectorAll('[data-cart-count]').forEach(el => {
            el.textContent = cart.item_count;
            el.style.display = cart.item_count > 0 ? '' : 'none';
          });
        }
      } catch (err) { /* fallback: let Dawn handle it */ }
    });
  });
});
